import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Hero.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Hero = () => {
  const { currentLang } = useContext(LanguageContext);
  const [hero, setHero] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/HeroSection?lang=${currentLang}`
        );
        setHero(res.data);
      } catch (error) {
        console.error("Error fetching Hero Section:", error);
      }
    };

    fetchHero();
  }, [currentLang]);

    const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    const timeout = setTimeout(() => {
      video.pause();       // stop after 10s
    }, 10000); // 10 seconds

    return () => clearTimeout(timeout);
  }, []);

  if (!hero) return null;

  return (
    <div className="voyah-hero no-rtl">

      <div className="hero-top-wrapper">
        <div className="hero-content">
          <h1>{hero.title}</h1>
          <h2>{hero.subtitle}</h2>

          <div className="hero-buttons">
            <Link to="/voyah-free" className="btn-whitehome">{hero.button1}</Link>
            <Link to="/voyah-free-build" className="btn-outlinehome">{hero.button2}</Link>
          </div>
        </div>

        <div
          className="scroll-down"
          onClick={() =>
            window.scrollTo({
              top: window.innerHeight,
              behavior: "smooth",
            })
          }
        >
          <span>Scroll down</span>
          <div className="arrow-down">↓</div>
        </div>
      </div>

      {/* HERO SLIDER — first slide only */}
      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        loop={false}
        pagination={false}
        navigation={false}
        className="hero-swiper"
      >
        {hero.video && (
          <SwiperSlide>
            <div className="hero-slide">
              <video
                ref={videoRef}
                className="hero-media"
                src={resolveUrl(hero.video)}
                autoPlay
                muted
                playsInline
              />
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};

export default Hero;


// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/pagination";

// import "./Hero.css";

// import heroVideo from "../../assets/videos/voyah-hero.mp4";
// import img1 from "../../assets/images/hero/heroslide1.webp";
// import img2 from "../../assets/images/hero/heroslide2.avif";

// const Hero = () => {
//   const [activeSlide, setActiveSlide] = useState(0);

//   // STATIC content
//   const hero = {
//     title: "VOYAH FREE",
//     subtitle: "Free to Dare",
//     button1: "Find out more",
//     button2: "Build your VOYAH FREE",

//     video: heroVideo,

//     images: [img1, img2]
//   };

//   const hideTop = activeSlide === 2; // slide 3

//   return (
//     <div className="voyah-hero no-rtl">

//       {/* TOP TEXT – hidden only in slide 3 */}
//       {!hideTop && (
//         <div className="hero-top-wrapper">
//           <div className="hero-content">
//             <h1>{hero.title}</h1>
//             <h2>{hero.subtitle}</h2>

//             <div className="hero-buttons">
//               <button className="btn-white">{hero.button1}</button>
//               <button className="btn-outline">{hero.button2}</button>
//             </div>
//           </div>

//           <div
//             className="scroll-down"
//             onClick={() =>
//               window.scrollTo({
//                 top: window.innerHeight,
//                 behavior: "smooth",
//               })
//             }
//           >
//             <span>Scroll down</span>
//             <div className="arrow-down">↓</div>
//           </div>
//         </div>
//       )}

//       {/* SLIDER */}
//       <Swiper
//         modules={[Pagination, Autoplay]}
//         slidesPerView={1}
//         loop
//         pagination={{ clickable: true }}
//         autoplay={{ delay: 7000 }}
//         className="hero-swiper"
//         onSlideChange={(s) => setActiveSlide(s.realIndex)}
//       >

//         {/* ===== SLIDE 1 — VIDEO + TEKST ===== */}
//         <SwiperSlide>
//           <div className="hero-slide">
//             <video
//               className="hero-media"
//               src={hero.video}
//               autoPlay
//               muted
//               loop
//               playsInline
//             />
//             <div className="hero-content hero-slide-overlay">
//               <h1>{hero.title}</h1>
//               <h2>{hero.subtitle}</h2>
//               <div className="hero-buttons">
//                 <button className="btn-white">{hero.button1}</button>
//                 <button className="btn-outline">{hero.button2}</button>
//               </div>
//             </div>
//           </div>
//         </SwiperSlide>

//         {/* ===== SLIDE 2 — IMAGE + TEKST ===== */}
//         <SwiperSlide>
//           <div className="hero-slide">
//             <img className="hero-media" src={img1} alt="hero-1" />
//             <div className="hero-content hero-slide-overlay">
//               <h1>{hero.title}</h1>
//               <h2>{hero.subtitle}</h2>
//               <div className="hero-buttons">
//                 <button className="btn-white">{hero.button1}</button>
//                 <button className="btn-outline">{hero.button2}</button>
//               </div>
//             </div>
//           </div>
//         </SwiperSlide>

//         {/* ===== SLIDE 3 — IMAGE + VETËM "VOYAH Dream" ===== */}
//         <SwiperSlide>
//           <div className="hero-slide">
//             <img className="hero-media" src={img2} alt="hero-2" />
//             <div className="hero-content hero-slide-overlay">
//               <h1>VOYAH Dream</h1>
//               <h2>Dream to Dare</h2>
//               <div className="hero-buttons">
//                 <button className="btn-white">{hero.button1}</button>
//                 <button className="btn-outline">Build your VOYAH Dream</button>
//               </div>
//             </div>
//           </div>
//         </SwiperSlide>

//       </Swiper>
//     </div>
//   );
// };

// export default Hero;

